import React, { useEffect, useState } from 'react'
import './index.css'
import { toastr } from 'react-redux-toastr'
import AffiliateLayout from './AffiliateLayout'
import AddUserModal from './AddUserModal'
import { connectAffiliate } from './Affiliate.connect'
import { useSelector } from 'react-redux'
import { BASE_URL } from '../../config/api.config'
import QRGenerator from './QRGenerator'
import TopLossUsersChart from './TopLossUsersChart'
import moment from 'moment'
import HowToget from './HowToget'
import HowTogetComm from './HowTogetComm'
import ShareModal from './ShareModal'

const AffiliateDashboard = ({ actions }) => {
  const [statusData, setStatusData] = useState(null)
  const [last5Aff, setLast5Aff] = useState(null)
  const [todayPl, setTodayPl] = useState(null)
  const [topLoss, setTopLoss] = useState(null)
  const [commissionInfo, setCommissionInfo] = useState(null)
  const [openBonus, setOpenBonus] = useState(false)
  const [openCommInfo, setCommInfo] = useState(false)
  const [share, setShare] = useState(false)
  const [open, setOpen] = useState(false)

  const affiliateCode = useSelector((state) => state.affiliateCode)

  const copyAffiliateLink = () => {
    const link = `${BASE_URL}/default-page?af_code=${affiliateCode?.affiliate_code}`
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toastr.success('', 'Link copied to clipboard!')
      })
      .catch((err) => {
        console.error('Failed to copy: ', err)
      })
  }

  const getAffUserCount = async () => {
    await actions
      .getAffUserCount()
      .then((res) => {
        if (res?.data?.status) {
          setStatusData(res?.data?.data)
        }
      })
      .catch((e) => toastr.error('', `${e}`))
  }

  const getLast5AffComm = async () => {
    await actions
      .getLast5AffComm()
      .then((res) => {
        if (res?.data?.status) {
          setLast5Aff(res?.data?.data?.last5Entries)
        }
      })
      .catch((e) => toastr.error('', `${e}`))
  }
  const getAffUserTodayPL = async () => {
    await actions
      .getAffUserTodayPL()
      .then((res) => {
        if (res?.data?.status) {
          setTodayPl(res?.data?.data?.response)
        }
      })
      .catch((e) => toastr.error('', `${e}`))
  }
  const getTop5LossUsers = async () => {
    await actions
      .getTop5LossUsers()
      .then((res) => {
        if (res?.data?.status) {
          setTopLoss(res?.data?.data)
        }
      })
      .catch((e) => toastr.error('', `${e}`))
  }
  const getAffBonusSetting = async () => {
    await actions
      .getAffBonusSetting()
      .then((res) => {
        if (res?.data?.status) {
          setCommissionInfo(res?.data?.data)
        } else {
          setCommissionInfo(null)
        }
      })
      .catch((e) => toastr.error('', `${e}`))
  }
  const getUserAffCode = async () => {
    await actions.getUserAffCode()
  }

  useEffect(() => {
    getAffUserCount()
    getLast5AffComm()
    getAffUserTodayPL()
    getUserAffCode()
    getTop5LossUsers()
    getAffBonusSetting()
  }, [])

  console.log(affiliateCode, 'affiliateCodeaffiliateCode')

  console.log(statusData, 'statusDatastatusData')
  return (
    <>
      <AffiliateLayout>
        <div className="nw-affi-how-to-get-bonus">
          <img
            src="/bonus/ellip-bg.svg"
            alt="ellip-bg"
            className="ellip-bg-img"
          />
          <div className="nw-affi-heading-flex">
            <h3 className="nw-affi-heading-text">Today Status</h3>
          </div>
          <div className="nw-affi-how-to-get-bonus-content">
            <div className="nw-affi-how-to-get-bonus-content-sec nw-affi-status-digit-para">
              <span className="nw-affi-status-digit">
                {statusData?.total_deposit_amount}
              </span>
              <p>Total deposit</p>
            </div>
            <div className="nw-affi-how-to-get-bonus-content-sec nw-affi-status-digit-para">
              <span className="nw-affi-status-digit">
                {statusData?.total_deposit_count}
              </span>
              <p>Total deposit count</p>
            </div>
            <div className="nw-affi-how-to-get-bonus-content-sec nw-affi-status-digit-para">
              <span className="nw-affi-status-digit">
                {statusData?.total_users}
              </span>
              <p>Total user</p>
            </div>
            <div className="nw-affi-how-to-get-bonus-content-sec nw-affi-status-digit-para">
              <span className="nw-affi-status-digit">
                {statusData?.total_affiliate_comm}
              </span>
              <p>Total commission</p>
            </div>
          </div>
        </div>
        <div className="nw-affi-invite-sec">
          <div className="nw-affi-invite-content-wrapper">
            <div className="nw-affi-invite-content">
              <h2>Invite your friends</h2>
              <p>to join and you can receive huge bonuses</p>
            </div>
            <div className="nw-affi-invite-img">
              <img src="/bonus/affi-invite-img.svg" alt="affi-invite-img" />
            </div>
          </div>
          <div className="nw-affi-add-new-user-btn-sec">
            <button
              className="nw-affi-add-new-user-btn"
              onClick={() => setOpen(!open)}
            >
              <span>
                <img src="/bonus/affi-add-user.svg" alt="affi-add-user" /> ADD
                NEW USER
              </span>
            </button>
          </div>
          <div className="nw-affi-qr-invite-wrapper">
            <div className="nw-affi-qr-invite-code">
              <div className="nw-affi-qr-invite-heading">
                <img src="/bonus/invite-gift.svg" alt="invite-gift" />
                <h3>Invitation Code</h3>
              </div>
              <div className="nw-affi-share-link-sec">
                <span>
                  {BASE_URL}/default-page?af_code=
                  {affiliateCode?.affiliate_code}
                </span>
              </div>
              <div className="affi-qr-btn-wrapper">
                <div className="nw-affi-qr-sec">
                  <QRGenerator
                    link={`${BASE_URL}?af_code=${affiliateCode?.affiliate_code}`}
                  />
                </div>
                <div className="af-form-btn-sec">
                  <button
                    onClick={copyAffiliateLink}
                    className="thm-but thm-bdr-btn affi-cancel-btn affi-yellow-btn"
                  >
                    <img src="/bonus/affi-copy.svg" alt="affi-copy" /> Copy Link
                  </button>
                  <button
                    className="nw-affi-add-new-user-btn"
                    data-bs-target="#ShareAffiliate"
                    data-bs-toggle="modal"
                    onClick={() => setShare(!share)}
                  >
                    Share
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TopLossUsersChart topLoss={topLoss} />

        {last5Aff?.length !== 0 && (
          <div className="nw-affi-last-report-sec bg-white p-2 rounded">
            <h3 style={{ color: '#c10930', fontSize: '16px', fontWeight: 600 }}>
              Last five Days Report
            </h3>
            <ul className=" nw-affi-last-report-list">
              {last5Aff?.map((item, index) => (
                <li key={index}>
                  <span style={{ fontWeight: 600 }}>
                    {moment.utc(item?.start_date).format('DD MMMM YYYY')}
                  </span>
                  <p style={{ color: '#28a745', fontWeight: 600, margin: 0 }}>
                    {item?.amount}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="nw-affi-how-to-get-bonus">
          <img
            src="/bonus/ellip-bg.svg"
            alt="ellip-bg"
            className="ellip-bg-img"
          />
          <div className="nw-affi-heading-flex">
            <h3 className="nw-affi-heading-text">Bonus Information</h3>
          </div>
          <div className="nw-affi-how-to-get-bonus-content">
            <div
              className="nw-affi-how-to-get-bonus-content-sec"
              onClick={() => setOpenBonus(!openBonus)}
            >
              <img src="/bonus/affi-bonus.svg" alt="affi-bonus-1" />
              <p>How to get bonus?</p>
            </div>
            <div
              className="nw-affi-how-to-get-bonus-content-sec"
              onClick={() => setCommInfo(!openCommInfo)}
            >
              <img src="/bonus/affi-bonus.svg" alt="affi-bonus-2" />
              <p>Commission Info</p>
            </div>
          </div>
        </div>
        <div className="af-top-user-sec">
          <div className="af-top-user-head af-new-user-add-sec">
            <h6>Today Profit and Loss</h6>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>PL</th>
                </tr>
              </thead>
              <tbody>
                {todayPl?.map((item) => {
                  return (
                    <tr key={item?.type}>
                      <td>{item?.type}</td>
                      <td
                        className={`green-font-color text-left font-semibold ${
                          item?.pl < 0 ? 'text-red-600' : 'text-green-600'
                        }`}
                      >
                        {item?.pl}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </AffiliateLayout>
      {open && (
        <AddUserModal getAffUserCount={getAffUserCount} setOpen={setOpen} />
      )}
      {openBonus && <HowToget setOpenBonus={setOpenBonus} />}
      {openCommInfo && (
        <HowTogetComm
          setOpenBonus={setCommInfo}
          commissionInfo={commissionInfo}
        />
      )}
      {share && <ShareModal setOpenBonus={setShare} />}
    </>
  )
}

export default connectAffiliate()(AffiliateDashboard)
